<div class="light-gray-bg tiny-padding-all minor-margin-bottom">
  <div class="grid-x">
    <div class="cell auto clearTitle break-word">
      {{title}}: <b>{{data.type}}</b>
    </div>
    <div class="cell shrink margin-left">
      @if (!isArray) {
        <button (click)="delete()" attr.aria-label="Delete '{{title}}'" title="Delete"><svg-icon icon="icon-trash" aria-hidden="true" class="small dark-gray cursor-pointer"></svg-icon></button>
      }
      @if (!newArray) {
        <button (click)="edit()" attr.aria-label="Edit '{{title}}'" title="Edit"><svg-icon icon="icon-pencil" aria-hidden="true" class="small dark-gray cursor-pointer"></svg-icon></button>
      }
      @if (newArray) {
        <button (click)="add()" attr.aria-label="Add New Array" title="Add New"><svg-icon icon="icon-plus" aria-hidden="true" class="small dark-gray cursor-pointer"></svg-icon></button>
      }
    </div>
  </div>
  <ng-template ebInnerComponentHost></ng-template>
</div>